/**
 * N.B. Alcuni script del dataLayer sono contenuti nei template (product impressions...)
 */

/** *****************************************************************************************
 * product clicks
 ***************************************************************************************** */

function tagManager_ProductClick(actionField, product) {

    if (env == 'dev') {
        console.log('productClick', actionField, product);
    }

    dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
            'click': {
                'actionField': {
                    'list': actionField
                },
                'products': [product]
            }
        }
    });
}

/** *****************************************************************************************
 * add to cart
 ***************************************************************************************** */

function tagManager_AddToCart(product) {

    if (env == 'dev') {
        console.log('addToCart', product);
    }

    dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
                'products': [product]
            }
        }
    });
}

/** *****************************************************************************************
 * remove from cart
 ***************************************************************************************** */

function tagManager_removeFromCart(product) {

    if (env == 'dev') {
        console.log('removeFromCart', product);
    }

    dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
            'remove': {
                'products': [product]
            }
        }
    });
}